import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config/config";

export const collectionsQuery = [
  {
    heading: "Styles for any Event",
    query: "women's black dress for party",
  },
  {
    heading: "Shop by your Budget",
    query: "unstitched 3 piece lawn suits under 5000",
  },
  {
    heading: "Effortless Outfit Matching",
    query: "formal sandals and shoes to pair with eastern wear",
  },
];

export const fetchCollections = createAsyncThunk(
  "collections/fetchCollections",
  async (_, { rejectWithValue }) => {
    try {
      let search = [];

      collectionsQuery.forEach((item) => {
        search.push(item.query);
      });

      const response = await axios.get(
        `${config.backendUrl}/inventory/batch_search`,
        {
          params: { q: search },
        },
      );

      return response.data?.results?.responses || [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch collections",
      );
    }
  },
);

const initialState = {
  collections: [],
  loading: false,
  error: null,
};

const collectionsSlice = createSlice({
  name: "collections",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCollections: (state) => {
      state.collections = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCollections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCollections.fulfilled, (state, action) => {
        state.loading = false;
        state.collections = action.payload;
      })
      .addCase(fetchCollections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearCollections } = collectionsSlice.actions;
export default collectionsSlice.reducer;
